import { render, staticRenderFns } from "./sanitaire.vue?vue&type=template&id=2aab927a"
import script from "./sanitaire.vue?vue&type=script&lang=js"
export * from "./sanitaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports